import Analytics from './index';

const install = function(Vue, router, initConf = {}) {
  let plugin = Analytics.instance();
  
  Vue.prototype.$stats = plugin;
};

export default { install };
